import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthTokenService } from '../shared/services/auth0-token.service';
 
@Injectable({ providedIn: 'root' })

export class AuthGuard  {

  constructor(private router: Router, private authTokenService: AuthTokenService) {}
 
  canActivate(): boolean | UrlTree {
   if (this.authTokenService.isAuthenticated()) {
    return true;
  }
   return this.router.parseUrl('/login');
  }

}
 